import React from 'react';
import {
  settingCreateColumnVisibilityObject,
  settingSelectedTableColumns,
} from '../../../utils/orgSettings';

class CampaignsMainViewStateController extends React.Component {
  state = {
    data: this.props.campaigns,
    openUpdateModal: false,
    openExportAbilityModal: false,
    selectedTableColumns: this.props.defaultColumns,
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    const sessionValues = JSON.parse(sessionStorage.getItem('defaultColumns'));

    const { orgTableConfig } = this.props;

    if (orgTableConfig && orgTableConfig.getOrgTableConfig) {
      this.applyOrgConfig(orgTableConfig.getOrgTableConfig);
    } else if (sessionValues) {
      this.setState({
        selectedTableColumns: sessionValues,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const hadConfig = prevProps.orgTableConfig && prevProps.orgTableConfig.getOrgTableConfig;
    const hasConfig = this.props.orgTableConfig && this.props.orgTableConfig.getOrgTableConfig;

    if (!this.orgConfigApplied && !hadConfig && hasConfig) {
      this.applyOrgConfig(this.props.orgTableConfig.getOrgTableConfig);
    }
  }

  applyOrgConfig = (config) => {
    this.orgConfigApplied = true;
    this.setState({
      selectedTableColumns: settingSelectedTableColumns(config, true),
    });
  };

  onRowChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys });
    this.setState({ selectedRows });
  };

  toggleUpdateModal = () => {
    this.setState({ openUpdateModal: !this.state.openUpdateModal });
  };

  toggleExportAbilityModal = () => {
    this.setState({
      openExportAbilityModal: !this.state.openExportAbilityModal,
    });
  };

  onTableColChange = async (key) => {
    let selectedKeys = [...this.state.selectedTableColumns];
    let index = selectedKeys.indexOf(key);
    const { currentUser, updateOrgTableConfig, orgTableConfig, orgTableConfigRefetch } = this.props;

    if (index >= 0) {
      selectedKeys.splice(index, 1);
    } else {
      selectedKeys = [...selectedKeys, key];
    }
    this.setState({ selectedTableColumns: selectedKeys });

    sessionStorage.setItem('defaultColumns', JSON.stringify(selectedKeys));

    const isShowObject = settingCreateColumnVisibilityObject(selectedKeys);

    if (orgTableConfig) orgTableConfig.getOrgTableConfig = isShowObject;
    this.orgConfigApplied = true;

    // Org-level campaign table display column settings
    await updateOrgTableConfig({
      variables: {
        id: currentUser.role.org.id,
        ...isShowObject,
      },
    });

    await orgTableConfigRefetch();
  };

  render() {
    return (
      <React.Fragment>
        {React.cloneElement(this.props.children, {
          onTableColChange: this.onTableColChange,
          toggleUpdateModal: this.toggleUpdateModal,
          toggleExportAbilityModal: this.toggleExportAbilityModal,
          onRowChange: this.onRowChange,
          ...this.state,
          ...this.props,
        })}
      </React.Fragment>
    );
  }
}

export default CampaignsMainViewStateController;
